// Host-aware ERP path helpers.
//
// On the dedicated subdomain (erp.yellowslate.com) the ERP is mounted at the
// ROOT, so its routes are /login, /dashboard, /students, … On the CRM domain
// (crm.yellowslate.com) the ERP lives under /erp/*. These helpers let shared
// components build the right paths without caring which host they're on.

export const isErpHost = (): boolean =>
  typeof window !== 'undefined' && window.location.hostname.startsWith('erp.');

// Base the ERP is mounted at: '' on the erp.* subdomain, '/erp' on the CRM domain.
export const erpBase = (): string => (isErpHost() ? '' : '/erp');

// Build an ERP route path. erpPath('dashboard') -> '/dashboard' (erp host) or '/erp/dashboard'.
export const erpPath = (sub = ''): string => {
  const s = String(sub).replace(/^\/+/, '');
  const base = erpBase();
  return s ? `${base}/${s}` : base || '/';
};
